import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { getMemberSourceTranslationKey } from "@msuite/utils/calculations";
import { moment } from "@msuite/utils/date";
import type { CalculationMemberListItem } from "@msuite/utils/types";
import { UserCard } from "@/components/cards";
import { CalculationFormMembersRowActions } from "./calculation-form-members-row-actions";

const columnHelper = createColumnHelper<CalculationMemberListItem>();

const MEMBER_SOURCE_COLOR = {
	"offer-match": "blue",
	manual: "gray",
} as const;

export const columns = [
	columnHelper.accessor("_user.name", {
		header: localized("general.name"),
		cell: (cell) => (
			<UserCard
				variant="plain"
				userId={cell.row.original.userId}
				withPopover={false}
			/>
		),
	}),
	columnHelper.accessor("source", {
		header: localized("general.source"),
		cell: (cell) => (
			<Tag
				variant="plain"
				color={MEMBER_SOURCE_COLOR[cell.getValue()]}
			>
				{localized(getMemberSourceTranslationKey(cell.getValue()))}
			</Tag>
		),
	}),
	columnHelper.accessor("createdAt", {
		header: localized("general_fields.created_at"),
		cell: (cell) => moment(cell.getValue()).dateFormat(),
	}),
	createRowActions(CalculationFormMembersRowActions),
];
